// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".viso-notification-list{padding-bottom:60px}", "",{"version":3,"sources":["webpack://./app/containers/Notification/components/NotificationList.scss"],"names":[],"mappings":"AAAA,wBACE,mBAAA","sourcesContent":[".viso-notification-list {\n  padding-bottom: 60px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
